import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import VRFIndoorDetail from '../../components/vrf/VRFIndoorDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { getVRFIndoor, editVRFIndoor } from '../../redux/vrf/vrf_indoor_actions';

class VRFIndoorEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isValid: false, isDirty: false, isSubmittable: false };
    this.detail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.indoor !== nextProps.indoor && nextProps.show) {
      this.props.get(nextProps.indoor.id);
    }
  }

  onSaveHandler() {
    const data = this.detail.getWrappedInstance().getWrappedInstance().getData();
    this.props.edit(this.props.indoor.id, data);
  }

  render() {
    const { isEditing, errorMessage, detailObj, edit, get, indoor, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal {...newProps} bsSize="large" aria-labelledby="contained-modal-title-lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t('edit vrf indoor')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VRFIndoorDetail
            indoor={detailObj}
            ref={ref => (this.detail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="vrf-indoor-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.vrfIndoor.errorMessage,
  isEditing: state.vrfIndoor.isEditing,
  detailObj: props.indoor && state.vrfIndoor.objects[props.indoor.id],
});

const mapDispatchToProps = dispatch => ({
  edit: (id, data) => defaultRejectHandler(dispatch(editVRFIndoor(id, data))),
  get: id => defaultRejectHandler(dispatch(getVRFIndoor(id))),
});

export default translate('translations')(
  connect(mapStateToProps, mapDispatchToProps)(VRFIndoorEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/vrf/VRFIndoorEditModal.js